import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, Directive, NgModule } from '@angular/core';

function XpoFooterComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Version - ", ctx_r0.version, "");
} }
const _c0 = ["*"];
class XpoFooterComponent {
    constructor() {
        this.currentYear = new Date().getFullYear();
    }
}
XpoFooterComponent.ɵfac = function XpoFooterComponent_Factory(t) { return new (t || XpoFooterComponent)(); };
XpoFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFooterComponent, selectors: [["xpo-footer"]], hostAttrs: [1, "xpo-Footer"], inputs: { version: "version" }, ngContentSelectors: _c0, decls: 7, vars: 2, consts: [[1, "xpo-Footer-container"], [1, "xpo-Footer-copy-and-version"], [1, "xpo-Footer-copy"], ["class", "xpo-Footer-version", 4, "ngIf"], [1, "xpo-Footer-navbar"], [1, "xpo-Footer-version"]], template: function XpoFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, XpoFooterComponent_div_4_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("\u00A9 ", ctx.currentYear, " XPO Logistics.");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.version);
    } }, directives: [i1.NgIf], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-Footer-container[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 -2px 6px #d8d8d8;display:flex;height:46px;justify-content:space-between}.xpo-Footer-copy-and-version[_ngcontent-%COMP%]{align-items:center;color:#333;display:flex;font-size:.875rem}.xpo-Footer-copy[_ngcontent-%COMP%]{margin-left:16px}.xpo-Footer-version[_ngcontent-%COMP%]{margin-left:8px}.xpo-Footer-navbar[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:row}@media only screen and (max-width: 768px){.xpo-Footer-container[_ngcontent-%COMP%]{align-items:center;flex-direction:column;height:auto}.xpo-Footer-copy-and-version[_ngcontent-%COMP%]{flex-direction:column}.xpo-Footer-navbar[_ngcontent-%COMP%]{flex-wrap:wrap;justify-content:center}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFooterComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-footer',
                templateUrl: './footer.component.html',
                styleUrls: ['./footer.component.scss'],
                host: {
                    class: 'xpo-Footer',
                },
            }]
    }], null, { version: [{
            type: Input
        }] }); })();

class XpoFooterStickyDirective {
}
XpoFooterStickyDirective.ɵfac = function XpoFooterStickyDirective_Factory(t) { return new (t || XpoFooterStickyDirective)(); };
XpoFooterStickyDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoFooterStickyDirective, selectors: [["", "xpo-footer-sticky", ""], ["", "xpoFooterSticky", ""]], hostAttrs: [1, "xpo-Footer--sticky"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFooterStickyDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-footer-sticky], [xpoFooterSticky]',
                host: {
                    class: 'xpo-Footer--sticky',
                },
            }]
    }], null, null); })();

class XpoFooterModule {
}
XpoFooterModule.ɵfac = function XpoFooterModule_Factory(t) { return new (t || XpoFooterModule)(); };
XpoFooterModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoFooterModule });
XpoFooterModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFooterModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoFooterComponent, XpoFooterStickyDirective],
                imports: [CommonModule],
                exports: [XpoFooterComponent, XpoFooterStickyDirective],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoFooterModule, { declarations: [XpoFooterComponent, XpoFooterStickyDirective], imports: [CommonModule], exports: [XpoFooterComponent, XpoFooterStickyDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoFooterComponent, XpoFooterModule, XpoFooterStickyDirective };
